import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable } from 'windowed-observable';

class LstEventsService {
    constructor() {
        this.defaultNamespace = 'defaultNamespace';
        this.defaultObservable = new Observable(this.defaultNamespace);
    }
    getObservable(namespace) {
        this.observableInstance = new Observable(namespace);
        return this.observableInstance;
    }
    /* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
    publishData(data, instance) {
        if (instance) {
            instance.publish(data);
        }
        else {
            this.defaultObservable.publish(data);
        }
    }
}
/** @nocollapse */ LstEventsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: LstEventsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ LstEventsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: LstEventsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: LstEventsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of lst-events
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LstEventsService };
//# sourceMappingURL=savvaslearning-lst-events.js.map
